import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: 'Is this suitable for professional electrical engineering work?',
  a: 'The system is designed to support electrical engineering tasks through structured prompts and reusable resources. AI-generated outputs must be reviewed against applicable standards, authoritative references, project requirements, and professional judgment before use.'
}, {
  q: 'Do I need to be a technology expert?',
  a: 'No advanced prompt-writing expertise is required to begin. The prompts provide structured starting points that you can adapt to your tasks, tools, and working methods.'
}, {
  q: 'Is this a one-time payment?',
  a: 'Yes. One-time payment with lifetime access and free updates.'
}, {
  q: 'What format will I receive?',
  a: 'The product is a digital resource delivered in PDF format, accessible from compatible desktop and mobile devices.'
}, {
  q: 'Which AI platforms are supported?',
  a: 'The prompts are intended for compatible AI assistants such as ChatGPT, Claude, Gemini, and other tools capable of processing the instructions. Results may vary by platform, model, and subscription level.'
}, {
  q: 'Can the AI make mistakes?',
  a: 'Yes. AI-generated information can contain errors, unsupported assumptions, or incomplete technical analysis. Always verify calculations, technical specifications, safety-related recommendations, and applicable requirements before relying on the output.'
}, {
  q: 'Can I use the prompts with my own projects?',
  a: 'Yes, you can adapt the prompts to your tasks by supplying appropriate project information and constraints. Follow applicable safety procedures, organizational policies, data protection requirements, and professional review processes.'
}, {
  q: 'Are the four bonuses included?',
  a: 'Yes. The bundle includes:\n· The Electrical Engineer AI Quick-Start Vault™\n· The Electrical Calculation Review Kit™\n· The Electrical Troubleshooting Field Guide™\n· The Engineering Report Template Vault™'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-label="Frequently asked questions" className="bg-transparent" data-id="element-41" data-mp="2fw24o4p94jf4">
      <div className="mx-auto max-w-3xl px-5 py-6" data-id="element-42" data-mp="2ay93jq2t2flp">
        <h2 className="text-center font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-43" data-mp="2azk4li4v9994">
          ❓ Frequently Asked Questions
        </h2>
        <div className="mt-10 divide-y divide-grape/10 overflow-hidden rounded-2xl border border-grape/15 bg-white" data-id="element-44" data-mp="33lwjgrt4si20">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-45" data-mp="2ulq9hfwn607l" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left transition-colors duration-150 ease-out hover:bg-lilac-soft focus:outline-none focus-visible:bg-lilac-soft" data-id="element-46" data-mp="2umhww3g34rms">
                  <span className="text-sm font-bold text-plum sm:text-base" data-id="element-47" data-mp="3uupoetsprsh5">{f.q}</span>
                  {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-grape" data-id="element-48" data-mp="2pcd48f4r9b2" /> : <PlusIcon className="h-5 w-5 shrink-0 text-plum/40" data-id="element-49" data-mp="2o15tymh7jf7" />}
                </button>
                <div className="grid transition-[grid-template-rows] duration-300 ease-out" style={{
              gridTemplateRows: isOpen ? '1fr' : '0fr'
            }} data-id="element-50" data-mp="7n43uz41gpdo">
                  <div className="overflow-hidden" data-id="element-51" data-mp="he8gvta5m05v">
                    <p className="whitespace-pre-line px-6 pb-5 text-sm leading-relaxed text-plum/70" data-id="element-52" data-mp="me37rwtxipqx">{f.a}</p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}